<template>
  <div class="error-container" v-if="isEditMode || showInReadMode" :class="{'relative': relative, 'is-edit-mode': isEditMode}">
    <div class="content-error">Donnée non disponible</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	props: {
		relative: {
			type: Boolean,
			default: false
		},
		showInReadMode: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters(["editor"]),
		isEditMode () {
			const result = this.editor.mode == "editing";
			return result;
		},
	},
};
</script>

<style lang="scss" scoped>
.error-container {
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  min-height: 50px;
  text-align: center;
  border-style: solid;
  border-width: 2px;

  &.is-edit-mode {
    opacity: 0.8;
    background-color: black;
    color: red;
    border-color: red;
  }

  &.relative {
    position: relative;
  }

  .content-error {
    position: absolute;
    text-align: center;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>